import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const MetadataListContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${themeGet('spacing.md')};
`;
